module.exports = __webpack_public_path__ + "static/media/Rey.a879ecb7.jpg";